<template>
  <div>
    <el-dialog
        v-model="dialog1Vis"
        title="Tips"
        width="500"
    >
      <template #header>
        <div class="my-header">
          <svg fill="none" viewBox="0 0 24 24"
               width="24" height="24" class="t-icon t-icon-info-circle-filled t-is-info">
            <path fill="#4285f4" d="M12 23a11 11 0 100-22 11 11 0 000 22zM11 8.5v-2h2v2h-2zm2 1.5v7.5h-2V10h2z">
            </path>
          </svg>
          <h4>信息</h4>
        </div>
      </template>
      <div class="content-txt">
        根据您当前填报信息，属于小型微利企业，依据政策可免于填报：<br/>
        《一般企业收入明细表》（A101010）<br/>
        《金融企业收入明细表》（A101020）<br/>
        《一般企业成本支出明细表》（A102010）<br/>
        《金融企业支出明细表》（A102020）<br/>
        《事业单位、民间非营利组织收入、支出明细表》（A103000）<br/>
        《期间费用明细表》（A104000）<br/>
        以及基础信息表“主要股东及分红情况”项目。<br/>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="on1Confirm">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog
        v-model="dialog2Vis"
        title="Tips"
        width="500"
    >
      <template #header>
        <div class="my-header">
          <svg fill="none" viewBox="0 0 24 24"
               width="24" height="24" class="t-icon t-icon-info-circle-filled t-is-info">
            <path fill="#4285f4" d="M12 23a11 11 0 100-22 11 11 0 000 22zM11 8.5v-2h2v2h-2zm2 1.5v7.5h-2V10h2z">
            </path>
          </svg>
          <h4>信息</h4>
        </div>
      </template>
      <div class="content-txt">
        尊敬的纳税人您好，当年汇算清缴申报完成后，如存在当年汇算清<br/>
        缴多缴税款的，可以即时通过电子税务局提交退抵税申请。
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="on2Confirm">
            已阅读
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
const dialog1Vis = ref(false)
const dialog2Vis = ref(false)

onMounted(() => {
  setTimeout(() => {
    dialog1Vis.value = true
  }, 500)
})

function on1Confirm() {
  dialog1Vis.value = false
  setTimeout(() => {
    dialog2Vis.value = true
  }, 500)
}

function on2Confirm() {
  dialog2Vis.value = false
}
</script>


<style scoped lang="scss">
.my-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 10px;

  > h4 {
    margin-left: 8px;
    font-weight: 700;
  }
}

.content-txt {
  font-size: 14px;
  line-height: 22px;
  color: #777777;
  padding: 0 10px;
}

.dialog-footer {
  padding-bottom: 15px;
  padding-right: 15px;
}
</style>
